// CPAYMENT-1530: side-effect entry point that initialises Sentry before any other
// module in the bundle evaluates. ES imports run before the importing module's body,
// so importing this file FIRST in src/index.tsx guarantees Sentry is up before the
// App / i18n / api.ts module tree is evaluated — capturing errors (and unhandled
// rejections) thrown during module load, independent of the CSRF / antifraud chain.
import { initSentry } from './sentryInit';

initSentry();
